/* ═══════════════════════════════════════════════════════
   AIC Pages JavaScript
   A.I.C.とは / 環境への取組 ページ共通スクリプト

   機能: Scroll Reveal (IntersectionObserver によるfade-up)
   外部ライブラリ不要
   ═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  // 古いブラウザ対策
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.aic-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  // reduce-motion ユーザーは即表示
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.aic-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -60px 0px',
    }
  );

  function init() {
    document.querySelectorAll('.aic-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /*
    Shopify のテーマエディター（カスタマイザー）でセクションが追加・再読み込みされた時の対応
    Shopify の標準イベントをリッスンして、新しく追加された reveal 要素も observe する
  */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('.aic-reveal').forEach(function (el) {
        if (!el.classList.contains('is-visible')) {
          observer.observe(el);
        }
      });
    });
  }
})();
